import { defineStore } from 'pinia'
import { getSeoInfo } from '@/api'

export const useSeoStore = defineStore('seo', {
  state: () => ({
    seo: {
      en: null,
      ar: null,
    },
    locale: 'en',
  }),

  actions: {
    async setLocale(locale) {
      this.locale = locale

      if (!this.seo[locale]) {
        this.seo[locale] = await getSeoInfo(locale)
      }
    },

    getGlobalSeo() {
      return this.seo[this.locale] || {}
    },
  },
})